import { render, staticRenderFns } from "./LayoutBanner.vue?vue&type=template&id=3054e3a8&scoped=true"
import script from "./LayoutBanner.vue?vue&type=script&lang=js"
export * from "./LayoutBanner.vue?vue&type=script&lang=js"
import style0 from "./LayoutBanner.vue?vue&type=style&index=0&id=3054e3a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_398719d9ba0fb65ce1cea3b2910bec76/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3054e3a8",
  null
  
)

export default component.exports